// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3s72p","buttons":"PendingPaymentAlert_buttons__2SNG3"};